import axios from '@/libs/http'

export const listClerkAgreement = ()=>{
    return axios.request({
        url: '/s/c/agreement/list',
        method: 'GET'
    })
}

export const confirmClerkAgreement = (agreementIdArray)=>{
    let data = new URLSearchParams()
    data.append('agreementIdArray',JSON.stringify(agreementIdArray))
    return axios.request({
        url: '/s/c/agreement/confirm',
        data,
        method: 'POST'
    })
}
